import React from 'react'

function Testimonial() {
 return (
 <div>
 {/* */} <div className="container-fluid bg-primary py-5 mb-5 hero-header">
 <div className="container">

   <div className="row justify-content-center">
 <div className="col-lg-10 text-center">
 <h1 className="display-3 text-white animated slideInDown">
 Hotels
 </h1>
 <nav aria-label="breadcrumb">
 <ol className="breadcrumb justify-content-center">
 <li className="breadcrumb-item">
 <a href="/">Acceuil</a>
 </li>
 <li
 className="breadcrumb-item text-white active"
 aria-current="page"
 >
 Hotels
 </li>
 </ol>
 </nav>
 </div>
 </div>
 </div>
 </div>
 {/* Testimonial Start */}
 <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
 <div className="container">
 <div className="text-center">
 <h6 className="section-title bg-white text-center text-primary px-3">
 Hotels
 </h6>
 <h1 className="mb-5"> Nos clients disent!!!</h1>
 </div>
 <div className="owl-carousel testimonial-carousel position-relative">
 <div className="testimonial-item bg-white text-center border p-4">
 <img alt='im'
 className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
 src="assets/img/testimonial-1.jpg"
 style={{ width: 80, height: 80 }}
 />
 <h5 className="mb-0">John Doe</h5>
 <p>New York, USA</p>
 <p className="mb-0">
 Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit diam
 amet diam et eos. Clita erat ipsum et lorem et sit.
 </p>
 </div>
 <div className="testimonial-item bg-white text-center border p-4">
 <img alt='im'
 className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
 src="assets/img/testimonial-2.jpg"
 style={{ width: 80, height: 80 }}
 />
 <h5 className="mb-0">John Doe</h5>
 <p>New York, USA</p>
 <p className="mt-2 mb-0">
 Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit diam
 amet diam et eos. Clita erat ipsum et lorem et sit.
 </p>
 </div>
 <div className="testimonial-item bg-white text-center border p-4">
 <img alt='im'
 className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
 src="assets/img/testimonial-3.jpg"
 style={{ width: 80, height: 80 }}
 />
 <h5 className="mb-0">John Doe</h5>
 <p>New York, USA</p>
 <p className="mt-2 mb-0">
 Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit diam
 amet diam et eos. Clita erat ipsum et lorem et sit.
 </p>
 </div>
 <div className="testimonial-item bg-white text-center border p-4">
 <img alt='im'
 className="bg-white rounded-circle shadow p-1 mx-auto mb-3"
 src="assets/img/testimonial-4.jpg"
 style={{ width: 80, height: 80 }}
 />
 <h5 className="mb-0">John Doe</h5>
 <p>New York, USA</p>
 <p className="mt-2 mb-0">
 Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit diam
 amet diam et eos. Clita erat ipsum et lorem et sit.
 </p>
 </div>
 </div>
 </div>
 </div>
 {/* Testimonial End */}
 </div>
 )
}

export default Testimonial
